import { render } from "./AppProfile.vue?vue&type=template&id=6474ce9a"
import script from "./AppProfile.vue?vue&type=script&lang=ts"
export * from "./AppProfile.vue?vue&type=script&lang=ts"
script.render = render

export default script